<template>
  <div id="botcon">
    <div class="bot">
      <div class="wrap">
        <div class="bot01">
          <div class="bot01Top">
            <img src="./img/tel.png">
            <div class="bot01TopCon">
              <div class="bot01TopConT">热线电话</div>
              <div class="bot01TopConB">021-64208893</div>
            </div>
          </div>
          <div class="bot01Bot">公司地址：上海市闵行区剑川路951号</div>
        </div>
        <div class="bot02">
          <div class="botTitle">关于我们</div>
          <router-link to="/aboutUs" class="botText">公司简介</router-link>
          <router-link to="/joinUs" class="botText">加入我们</router-link>
        </div>
        <div class="bot03">
          <div class="botTitle">产品与服务</div>
          <router-link to="/productsCenter" class="botText">产品中心</router-link>
          <!-- <router-link to="/solution" class="botText">解决方案</router-link> -->
          <div class="botText" @click="push({ name: 'Solution'})">解决方案</div>
        </div>
        <div class="bot04">
          <div class="botTitle">合作交流</div>
          <div class="botText">微信公众号：hangshutech</div>
          <div class="botText">邮箱：hr@hangshutech.com</div>
        </div>
        <div class="bot05">
          <div class="bot05Title">关注微信公众号</div>
          <img src="./img/ewm.jpg">
        </div>
      </div>
    </div>
    <div class="footer">
      <span>© 2018 上海航数智能科技有限公司</span>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo">沪公网备案31011202010308号</a>
      <a href="https://beian.miit.gov.cn/#/Integrated/index">沪ICP备16041202号-2</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Botcon',
  data () {
    return {
    }
  },
  methods: {
    push (route) {
      this.$router.push(route)
    }
  }
}
</script>
<style scoped>
.bot{ width: 100%; height: 347px; color: #fffeff; background: #11223a;}
.bot01{ width: 356px; padding-top: 96px; float: left;}
.bot01Top{ width: 304px; height: 139px; background: #182940;}
.bot01Top img{ display: block; width: 46px; height: 42px; float: left; margin:57px 20px 0;}
.bot01TopCon{ margin: 53px 0 0; float: left;}
.bot01TopConT{ font-size: 18px; padding-bottom: 10px; line-height: 20px;}
.bot01TopConB{ font-size: 22px; line-height: 24px;}
.bot01Bot{ padding-top: 22px; font-size: 16px;}

.bot02{ margin-right: 88px; float: left;}
.bot03{ margin-right: 74px; float: left;}
.bot04{ margin-right: 100px; float: left;}

.botTitle{ font-size: 20px; line-height: 22px; padding: 112px 0 40px;}
.botText{ display: block; font-size: 16px; line-height: 34px; color: #fffeff;}

.bot05{ width: 160px; float: right;}
.bot05Title{ font-size: 20px; line-height: 22px; padding: 64px 0 28px;}
.bot05 img{ display: block; width: 149px; height: 149px;}
.footer{ width: 100%; height: 50px; text-align: center; font-size: 16px; color: #11223a; line-height: 50px;}
</style>



// WEBPACK FOOTER //
// src/components/base/Botcon/index.vue